var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMyModels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.17157 3.17138C2 4.34296 2 6.22857 2 9.99981V13.9998C2 17.771 2 19.6567 3.17157 20.8282C4.34315 21.9998 6.22876 21.9998 10 21.9998H14C17.7712 21.9998 19.6569 21.9998 20.8284 20.8282C22 19.6567 22 17.7711 22 13.9998V13.9998V9.99981C22 7.16047 22 5.38999 21.5 4.18837V16.9998C20.5396 16.9998 19.6185 16.6183 18.9393 15.9392L18.1877 15.1875C17.4664 14.4662 17.1057 14.1055 16.6968 13.9535C16.2473 13.7865 15.7527 13.7865 15.3032 13.9535C14.8943 14.1055 14.5336 14.4662 13.8123 15.1875L13.6992 15.3006C13.1138 15.886 12.8212 16.1786 12.5102 16.2332C12.2685 16.2756 12.0197 16.2277 11.811 16.0986C11.5425 15.9324 11.3795 15.552 11.0534 14.7911L11 14.6665C10.2504 12.9173 9.87554 12.0427 9.22167 11.7149C8.89249 11.5499 8.52413 11.479 8.1572 11.5099C7.42836 11.5715 6.75554 12.2443 5.40989 13.5899L3.5 15.4998V2.88721C3.3844 2.97331 3.27519 3.06776 3.17157 3.17138Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10C3 8.08611 3.00212 6.75129 3.13753 5.74416C3.26907 4.76579 3.50966 4.2477 3.87868 3.87868C4.2477 3.50966 4.76579 3.26907 5.74416 3.13753C6.75129 3.00212 8.08611 3 10 3H14C15.9139 3 17.2487 3.00212 18.2558 3.13753C19.2342 3.26907 19.7523 3.50966 20.1213 3.87868C20.4903 4.2477 20.7309 4.76579 20.8625 5.74416C20.9979 6.75129 21 8.08611 21 10V14C21 15.9139 20.9979 17.2487 20.8625 18.2558C20.7309 19.2342 20.4903 19.7523 20.1213 20.1213C19.7523 20.4903 19.2342 20.7309 18.2558 20.8625C17.2487 20.9979 15.9139 21 14 21H10C8.08611 21 6.75129 20.9979 5.74416 20.8625C4.76579 20.7309 4.2477 20.4903 3.87868 20.1213C3.50966 19.7523 3.26907 19.2342 3.13753 18.2558C3.00212 17.2487 3 15.9139 3 14V10Z",
    stroke: "white",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 9,
    r: 2,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyModels);
export default __webpack_public_path__ + "static/media/icon-my-models.5cdadaf65ac39c94f1d3199c2f2ef611.svg";
export { ForwardRef as ReactComponent };